import { StyledSwipeModal } from './modal.styles';

import React, { useEffect } from 'react';

export interface SwipeModalRef {
  closeModal: (callback?: VoidFunction) => void;
}

interface MobileModalProps {
  children: React.ReactNode;
  onClose?: VoidFunction;
  hideMobileCloseButton?: boolean;
}

export const MobileModal = React.forwardRef<SwipeModalRef, MobileModalProps>(
  ({ children, onClose: handleClose, hideMobileCloseButton }, ref) => {
    useEffect(() => {
      const { scrollY } = window;
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = '100%';

      return () => {
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        window.scrollTo({ top: 0, behavior: 'smooth' });
      };
    }, []);

    return (
      <StyledSwipeModal
        ref={ref}
        data-testid="mobile-modal-window"
        data-cy="modal-window"
        content={children}
        onClose={handleClose}
        reverseAnimation={false}
        hideMobileCloseButton={hideMobileCloseButton}
      />
    );
  },
);

MobileModal.displayName = 'MobileModal';
